module.exports = __webpack_public_path__ + "e94668e5bdb3f8d2290ec790ce8fd2c8.png";